export default __webpack_public_path__ + "static/media/6.53dfa358.jpg";